import { buildProps, definePropType } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type IconBasePro from './icon-base-pro.vue'

const iconTypes = ['default', 'primary'] as const

export const iconBaseProProps = buildProps({
  // 图标类型
  iconType: {
    type: String,
    values: iconTypes,
  },
  // 图标类名
  class: {
    type: String,
    default: '',
  },
  size: {
    type: definePropType<SizeType | number>([String, Number]),
    default: 'small',
  },
  // 文字提示类名
  tooltipClass: {
    type: String,
    default: '',
  },
  // 是否显示文字提示
  showTip: {
    type: Boolean,
    default: true,
  },
  // 文字提示文本
  tipText: {
    type: String,
  },
  // 文本
  label: {
    type: String,
    default: '',
  },

  // 是否禁用
  disabled: {
    type: Boolean,
  },
  // 图标名
  iconName: {
    type: String,
  },
  // 图标大小
  iconSize: {
    type: Number,
  },
  // 悬浮提示背景是否为白色
  isWhiteBg: {
    type: Boolean,
    default: true,
  },
  // 悬浮提示是否显示箭头
  arrow: {
    type: Boolean,
    default: false,
  },
  // 默认背景色
  bgColor: {
    type: String,
    default: '',
  },
  // 悬浮背景色
  hoverBgColor: {
    type: String,
    default: '',
  },
  // 图标悬浮放大倍率
  hoverScale: {
    type: Number,
    default: 1,
  },
} as const)

// props
export type IconBaseProProps = ExtractPropTypes<typeof iconBaseProProps>

// instance
export type IconBaseProInstance = InstanceType<typeof IconBasePro>
